import React from "react";
import ReactDOM from "react-dom";
import { Provider as ReduxProvider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store from "./store/store";
import "antd/dist/antd.css";
import "./index.css";

ReactDOM.render(
	<ReduxProvider store={store}>
		<Router onUpdate={() => window.scrollTo(0, 0)}>
			<App/>
		</Router>
	</ReduxProvider>,
	document.getElementById("root")
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
